import checkDimensions from "./checkDimensions";
import {
	ShipmentFieldsConfig,
	ValidationPatternsExplicit,
	ShipmentField,
} from "../../types";
const validateFormOnSubmit = (
	data: Record<string, any>,
	setError: any,
	clearErrors: any,
	fields: ShipmentFieldsConfig,
	getValues: any
) => {
	const validationPatterns: ValidationPatternsExplicit = {
		number: {
			regex: /^[0-9]*\.?[0-9]*$/,
			message: "Only numbers allowed.",
		},
		decimal: {
			regex: /^[0-9]*\.?[0-9]*$/,
			message: "Invalid format.",
		},
		cost: {
			regex: /^[0-9]+(\.[0-9]{1,2})?$/,
			message: "Enter valid cost.",
		},
	};

	// checking each field, if it is missing or has invalid value then throw error
	// if not, then clear error
	fields.DUMMYUPDATESHIPMENTFIELDS?.forEach((fieldSection) => {
		fieldSection.fields.forEach((field: ShipmentField) => {
			let value = getValues(field.valueKey);

			if (field.isRequired && !value) {
				setError(field.valueKey, {
					type: "manual",
					message: "Required field.",
				});
			} else if (
				value &&
				field.hasTypeCheck &&
				validationPatterns[field.hasTypeCheck]
			) {
				const pattern = validationPatterns[field.hasTypeCheck];
				if (!pattern.regex.test(value)) {
					setError(field.valueKey, {
						type: "manual",
						message: pattern.message,
					});
				}
			} else {
				clearErrors(field.valueKey);
			}
		});
	});

	// checking weight on it's own
	// if no errors, reset error field
	if (!data.weight) {
		setError("weight", {
			type: "manual",
			message: "Required field.",
		});
	} else if (data.weight) {
		const pattern = validationPatterns["decimal"];
		if (!pattern.regex.test(data.weight)) {
			setError("weight", {
				type: "manual",
				message: pattern.message,
			});
		}
	} else {
		clearErrors("weight");
	}

	// checking dimensions on its own
	// logic extracted into a separate function
	checkDimensions(data, setError, clearErrors);
};

export default validateFormOnSubmit;
